module.exports = __webpack_public_path__ + "static/media/caret-right.29a63cd9.svg";